export default __webpack_public_path__ + "static/media/errorImage.11e1329b.svg";